module.exports = __webpack_public_path__ + "static/media/cloud-drizzle.5d1b06a8.svg";